'use strict';

module.exports = (key, result) => result;